import React, { Component } from 'react'
import { Paragraph, Box, Button } from 'grommet';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import HeaderLogout from './HeaderLogout';
import Footer from './Footer';
import { logout } from '../Utils/Utility';
import ModalPasswordResponse from './ModalPasswordResponse';

class RiepilogoOTP extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.redirectSetting = this.redirectSetting.bind(this);
        this.redirectSettingFistStep = this.redirectSettingFistStep.bind(this);
        this.logout = this.logout.bind(this);
        this.redirectHome = this.redirectHome.bind(this);
    }


    redirectSettingFistStep() {
        this.props.firstStep();
    }

    redirectSetting() {
        this.props.history.push('/Setting');
    }

    redirectHome() {
        this.props.history.push('/Home');
    }

    logout() {
        localStorage.clear();
        sessionStorage.clear();
        this.props.history.push('/login')
    }

    render() {
        
        const outcome =
        <Box>
            {window.location.pathname === '/InsertTelephone' ?
                <Box>
                    <HeaderLogout />
                    <Box style={{ height: '81px' }}></Box>
                    <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>
                        <Box className='contentbox' style={{ height: '483px' }}>
                            <Box direction="column" align='center'>
                                <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>{this.props.values.dataOTP ? "Operazione andata a buon fine!" : "Operazione non andata a buon fine!"}</h1>
                                <Paragraph className='textParagraph' style={{ textAlign: 'center' }}>{this.props.values.dataOTP ? "La modifica è stata effettuata correttamente. Rieffettuare la login per continuare le operazioni nel portale" : "Spiacenti, la modifica richiesta non è andata a buon fine."}</Paragraph>
                            </Box>
                            {this.props.values.status === 200 ?
                                <Box direction='row' margin='xlarge'>
                                    <Box className='informativa' align='center' >
                                        <Button focusIndicator={false} color='transparent' className='btnform' label='LOGIN' onClick={logout} />
                                    </Box>
                                </Box>

                                :
                                <Box direction='row' margin='xlarge'>
                                    <Box className='informativa' align='start'>
                                        <Button focusIndicator={false} color='transparent' className='btnform' label='RIPROVA' onClick={this.redirectSettingFistStep} />
                                    </Box>
                                    <Box className='informativa' align='end'>
                                        <Button focusIndicator={false} color='transparent' className='btnform' label='LOGIN' onClick={logout} />
                                    </Box>
                                </Box>
                            }
                        </Box>
                    </Box>
                    <Footer />
                </Box>

                :

                <Box style={{ height: '500px' }}>
                    
                    <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>{this.props.values.status === 200 ? "Operazione andata a buon fine!" : "Operazione non andata a buon fine!"}</h1>
                    <Paragraph className='textParagraph' style={{ textAlign: 'center' }}>{this.props.values.status === 200 ? "La modifica è stata effettuata correttamente.\nPer vedere la modifica riesegui la login." : "Spiacenti, la modifica richiesta non è andata a buon fine."}</Paragraph>
                    {window.location.pathname === '/ChangePassword' || window.location.pathname === '/AggiornaPassword' ?
                        <Box direction='row' margin='xlarge'>
                            <Box className='informativa' align='center' >
                                <Button focusIndicator={false} color='transparent' className='btnform' label='LOGIN' onClick={logout} />
                            </Box>
                        </Box>
                    : ''}
                </Box>



            }
        </Box>


        const {values} = this.props;

        return (
            <Box style={{ margin: window.location.pathname !== '/InsertTelephone' ? '0 auto' : '' }}>
                {outcome}
                {(values.dataOTP === true && window.location.pathname === '/ModificaPassword') && <ModalPasswordResponse/> }
            </Box>
        )
    }
}

export default withRouter(RiepilogoOTP)